// src/app/services/sw-update.service.ts
import { Injectable } from '@angular/core';
import { NativeSwUpdateService } from './native-sw-update.service';

@Injectable({ providedIn: 'root' })
export class SwUpdateService {
  private initialized = false;

  constructor(private nativeSwUpdate: NativeSwUpdateService) {}

  /**
   * Call once during app bootstrap (e.g. AppComponent.ngOnInit) to run the first
   * service worker update check. Periodic polling is handled by
   * NativeSwUpdateService and UpdatePWAService.
   *
   * The custom service-worker.js calls skipWaiting() at the end of install and
   * clients.claim() on activate, so a new version never parks in "waiting" and
   * there is no VERSION_READY / unrecoverable state for the app to react to.
   */
  init(): void {
    if (!('serviceWorker' in navigator) || this.initialized) return;
    this.initialized = true;

    this.nativeSwUpdate.checkForUpdate().catch((err) => {
      console.error('[SW Update] Initial update check failed:', err);
    });
  }

  async activateAndReload(): Promise<void> {
    if (!navigator.serviceWorker) return;

    try {
      // Get the waiting service worker
      const registration = await navigator.serviceWorker.getRegistration();

      if (registration?.waiting) {
        // Tell SW to skip waiting
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Reload the page
      window.location.reload();
    } catch (error) {
      console.error('[SW Update] Failed to activate update:', error);
      window.location.reload(); // fallback
    }
  }
}
